import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

const routes: Routes = [
  { path: 'home', loadChildren: () => import('@app/modules/home/home.module').then(m => m.HomeModule) },
  { path: 'users', loadChildren: () => import('@app/modules/users/users.module').then(m => m.UsersModule) },
  { path: 'subscriptions', loadChildren: () => import('@app/modules/subscriptions/subscriptions.module').then(m => m.SubscriptionsModule) },
  { path: 'activities', loadChildren: () => import('@app/modules/activities/activities.module').then(m => m.ActivitiesModule) },
  { path: 'customerrequests', loadChildren: () => import('@app/modules/customer-requests/customer-requests.module').then(m => m.CustomerRequestsModule) },
  { path: 'administrators', loadChildren: () => import('@app/modules/administrators/administrators.module').then(m => m.AdministratorsModule) },
  { path: 'statistics', loadChildren: () => import('@app/modules/statistics/statistics.module').then(m => m.StatisticsModule) },
  { path: 'profile-requests', loadChildren: () => import('@app/modules/profiles/profiles.module').then(m => m.ProfilesModule) },
  { path: 'validation-requests', loadChildren: () => import('@app/modules/validation-requests/validation-requests.module').then(m => m.ValidationRequestsModule) },
  { path: 'error/:code', loadChildren: () => import('@app/modules/errors/errors.module').then(m => m.ErrorsModule) },
  { path: 'transactions', loadChildren: () => import('@app/modules/transactions/transactions.module').then(m => m.TransactionsModule) },
  { path: 'access-media', loadChildren: () => import('@app/modules/access-media/access-media.module').then(m => m.AccessMediaModule) },
  { path: 'content-management', loadChildren: () => import('@app/modules/content-management/content-management.module').then(m => m.ContentManagementModule) },
  { path: 'parameters', loadChildren: () => import('@app/modules/parameters/parameters.module').then(m => m.ParametersModule) },
  { path: 'tools', loadChildren: () => import('@app/modules/admin-tools/admin-tools.module').then(m => m.AdminToolsModule) },
  { path: 'maintenance', loadChildren:() => import('@app/modules/maintenance/maintenance.module').then(m => m.MaintenanceModule) },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/error/404' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}
